import { CompensationHistoryInterface } from '../../models/history';
import { useEffect, useState } from 'react';
import { useHistoryProvider } from '../../providers/HistoryProvider';
import { useTranslation } from 'react-i18next';
// import { VIEW_TYPE } from '../../constants/common';
import { formatDateInDDMMYYYY, getUtcDate } from '../../helpers/date';
import { v4 as uuidv4 } from 'uuid';

export const useCompensationHistoryIFS = () => {
    const historyContext = useHistoryProvider();
    const { t } = useTranslation();

    const [compensationVouchers, setCompensationVouchers] = useState<string[]>();
    const [rows, setRows] = useState<CompensationHistoryInterface[]>([]);
    // const [viewType, setViewType] = useState(VIEW_TYPE.web);
    const [showPopUp, setShowPopUp] = useState<boolean>(false);
    const [pendingShowPopUp, setPendingShowPopUp] = useState(false);

    // useEffect(() => {
    //     const maxIpadPx = 1380;

    //     const handleResize = () => {
    //         setViewType(window.innerWidth <= maxIpadPx ? VIEW_TYPE.mobile : VIEW_TYPE.web);
    //     };

    //     handleResize();
    //     window.addEventListener('resize', handleResize);
    //     return () => window.removeEventListener('resize', handleResize);
    // }, []);

    useEffect(() => {
        if (!historyContext.loading.history) {
            setRows(historyContext.historyIfs.map(v => {
                const isError = v.voucherStatusCode === 'FAILED' || v.voucherStatusCode === 'ERR';
                return {
                    bookingReference: v.pnrLocator,
                    comments: v?.voucherIssuanceComment ?? '',
                    customer: `${v.passengerFirstName} ${v.passengerLastName}`,
                    date: formatDateInDDMMYYYY(getUtcDate(v.flightScheduledAt)),
                    email: v.passengerEmailAddress,
                    error: isError,
                    errorMessage: isError ? (v.responseStatusCode != null ? t(`notifications.history.${v.responseStatusCode.toString()}`) || '' : '') : '',
                    flight: `${v.marketingCarrier}${v.flightLegNumber}`,
                    groupId: v.groupId,
                    id: v.voucherIds[0] ? v.voucherIds[0] : uuidv4(),
                    qty: v.qty ?? 1,
                    reason: v?.voucherIssuanceReason ?? '',
                    reasonId: v?.reasonId,
                    categoryId: v?.categoryId,
                    cabinId: v?.cabinId,
                    status: v?.voucherStatusCode ?? '',
                    subType: v?.voucherSubTypeCode ?? '',
                    type: v?.voucherTypeCode ?? '',
                    voucherIds: v.voucherIds,
                    requestId: v.requestId
                }
            }));
        }
    }, [historyContext.historyIfs, historyContext.loading.history, t]);

    useEffect(() => {
        if (historyContext.historyCompensationCodes.length) {
            setCompensationVouchers(historyContext.historyCompensationCodes);
        }
    }, [historyContext.historyCompensationCodes]);

    // const sendCompensationCodes = (row) => {
    //     const resendPayload: ResendCompensationPayload = {
    //         pnrLocator: row.pnrLocator,
    //         voucherIds: row.voucherIds.slice(),
    //         voucherStatus: row.voucherStatusCode,
    //         voucherType: row.voucherTypeCode
    //     }
    //     historyContext.resendCompensation(resendPayload);
    // };

    const showCompensationCodes = (row: CompensationHistoryInterface) => {
        const viewCodePayload: string[] = row.voucherIds.slice();
        historyContext.viewCompensationCodes(viewCodePayload);
        setPendingShowPopUp(true);
    };

    useEffect(() => {
        if (pendingShowPopUp && !historyContext.loading.voucherCode) {
            setShowPopUp(true);
            setPendingShowPopUp(false);
        }
    }, [pendingShowPopUp, historyContext.loading.voucherCode]);

    return {
        historyContext,
        compensationVouchers,
        rows,
        showPopUp,
        setShowPopUp,
        showCompensationCodes,
        t
    };
};

